<div class="zn-form" [formGroup]="form">
<fieldset>
  <legend>
    {{`${localizationResource}::Stand.BasicInformation`| abpLocalization}}
    <hr />
  </legend>

  <div class="row">
    <div class="col-4">
      <div class="form-control-container">
        <label class="form-label" for="StandName">
          {{`${localizationResource}::Stand.Stand`| abpLocalization}}
          <span class="form-label-required">*</span>
        </label>
        <input
          id="StandName"
          class="form-control"
          type="text"
          formControlName="StandName"
          [attr.maxlength]="standNameMaxLength"
          [placeholder]="`${localizationResource}::EnterText` | abpLocalization"
          (blur)="form.get('StandName')?.setValue(form.get('StandName')?.value?.trim())"
        />
        @if (fieldInvalid('StandName')) { @if
        (form.get('StandName')?.hasError('required')) {
        <small class="invalid-feedback d-block">{{`${localizationResource}::DefaultErrorRequired` | abpLocalization}}</small>
        } @if (form.get('StandName')?.hasError('whitespace')) {
        <small class="invalid-feedback d-block"
          >{{`${localizationResource}::DefaultErrorNoWhiteSpace` | abpLocalization}}</small
        >
        } }
      </div>
    </div>

    <div class="col-4">
      <div class="form-control-container">
        <label class="form-label" for="StandArea">
          {{`${localizationResource}::Stand.StandArea`| abpLocalization}}
          <span class="form-label-required">*</span>
        </label>
        <input
          id="StandArea"
          class="form-control"
          type="number"
          formControlName="StandArea"
          min="0.01"
          step="0.01"
          inputmode="decimal"
          [placeholder]="`${localizationResource}::EnterNumber` | abpLocalization"
        />
        @if (fieldInvalid('StandArea')) { @if
        (form.get('StandArea')?.hasError('required')) {
        <small class="invalid-feedback d-block">{{`${localizationResource}::DefaultErrorRequired` | abpLocalization}}</small>
        } @if (form.get('StandArea')?.hasError('min')) {
        <small class="invalid-feedback d-block">{{`${localizationResource}::MustBeGreaterThan` | abpLocalization : '0'}}</small>
        } @if (form.get('StandArea')?.hasError('maxDecimals')) {
        <small class="invalid-feedback d-block">
          {{`${localizationResource}::InvalidDecimalScale` | abpLocalization : form.get('StandArea')?.getError('maxDecimals').max }}
        </small
        >
        } }
      </div>
    </div>

    <div class="col-4">
      <lib-stand-gis
      [canFetchGisArea]="canFetchGisArea()"
      [name]="this.form.get('StandName')?.value"
       (updatedGisArea)="onUpdateGisArea($event)"
      ></lib-stand-gis>
    </div>
  </div>

  <div class="row">
    <div class="col-4">
      <div class="form-control-container">
        <label class="form-label" for="PropertyId">
          {{`${localizationResource}::Stand.Establishment`| abpLocalization}}
          <span class="form-label-required">*</span>
        </label>
        <zn-single-select
          id="PropertyId"
          [options]="propertyOptions()"
          [optionsLoader]="loadProperty"
          [showSearch]="true"
          formControlName="PropertyId"
          [errorEntityKey]="`${localizationResource}::DefaultErrorRequired` | abpLocalization"
          [localizationResource]="localizationResource"
          [openUp]="false"
        >
        </zn-single-select>
        @if (fieldInvalid('PropertyId')) { @if
        (form.get('PropertyId')?.hasError('required')) {
        <small class="invalid-feedback d-block">{{`${localizationResource}::DefaultErrorRequired` | abpLocalization}}</small>
        } }
      </div>
    </div>

    <div class="col-4">
      <div class="form-control-container">
        <label class="form-label" for="StandTypeId">
          {{`${localizationResource}::Stand.StandType`| abpLocalization}}
          <span class="form-label-required">*</span>
        </label>
        <zn-single-select
          id="StandTypeId"
          [options]="standTypeOptions()"
          [optionsLoader]="loadsSandType"
          [showSearch]="true"
          formControlName="StandTypeId"
          [errorEntityKey]="`${localizationResource}::DefaultErrorRequired`"
          [localizationResource]="localizationResource"
          [openUp]="false"
        >
        </zn-single-select>
        @if (fieldInvalid('StandTypeId')) { @if
        (form.get('StandTypeId')?.hasError('required')) {
        <small class="invalid-feedback d-block">{{`${localizationResource}::DefaultErrorRequired` | abpLocalization}}</small>
        } }
      </div>
    </div>

    <div class="col-4">
      <div class="form-control-container">
        <label class="form-label" for="HasNearbyPopulation">
          {{`${localizationResource}::Stand.NearbyPopulation`| abpLocalization}}
          <span class="form-label-required">*</span>
        </label>
        <zn-simple-select
          id="HasNearbyPopulation"
          [options]="hasNearbyPopulationOptions"
          formControlName="HasNearbyPopulation"
          [localizationResource]="localizationResource"
          [placeholder]="'SelectOption'"
        >
        </zn-simple-select>
        @if (fieldInvalid('HasNearbyPopulation')){ @if
        (form.get('HasNearbyPopulation')?.hasError('required')){
        <small class="invalid-feedback d-block">{{`${localizationResource}::DefaultErrorRequired` | abpLocalization}}</small>
        } }
      </div>
    </div>
  </div>
</fieldset>

<fieldset>
  <legend>
    {{`${localizationResource}::Stand.CycleRotation`| abpLocalization}}
    <hr />
  </legend>

  <div class="row">
    <div class="col-4">
      <div class="form-control-container">
        <label class="form-label" for="CurrentCycle">
          {{`${localizationResource}::Stand.Cycle`| abpLocalization}} @if
          (cycleRotationRequired()) {
          <span class="form-label-required">*</span>
          }
        </label>
        <input
          id="CurrentCycle"
          class="form-control"
          type="number"
          formControlName="CurrentCycle"
          min="1"
          step="1"
          inputmode="numeric"
          [placeholder]="`${localizationResource}::EnterNumber` | abpLocalization"
        />
        @if (fieldInvalid('CurrentCycle')) { @if
        (form.get('CurrentCycle')?.hasError('required')) {
        <small class="invalid-feedback d-block">{{`${localizationResource}::DefaultErrorRequired` | abpLocalization}}</small>
        } @if (form.get('CurrentCycle')?.hasError('pattern')) {
        <small class="invalid-feedback d-block">{{`${localizationResource}::MustBeInteger` | abpLocalization}}</small>
        } @else if (form.get('CurrentCycle')?.hasError('min')) {
        <small class="invalid-feedback d-block"
          >{{`${localizationResource}::MustBeGreaterThan` | abpLocalization : '0'}}</small
        >
        } }
      </div>
    </div>

    <div class="col-4">
      <div class="form-control-container">
        <label class="form-label" for="CurrentRotation">
          {{`${localizationResource}::Stand.Rotation`| abpLocalization}} @if
          (cycleRotationRequired()) {
          <span class="form-label-required">*</span>
          }
        </label>
        <input
          id="CurrentRotation"
          class="form-control"
          type="number"
          formControlName="CurrentRotation"
          min="1"
          step="1"
          inputmode="numeric"
          [placeholder]="`${localizationResource}::EnterNumber` | abpLocalization"
        />
        @if (fieldInvalid('CurrentRotation')) { @if
        (form.get('CurrentRotation')?.hasError('required')) {
        <small class="invalid-feedback d-block">{{`${localizationResource}::DefaultErrorRequired` | abpLocalization}}</small>
        } @if (form.get('CurrentRotation')?.hasError('pattern')) {
        <small class="invalid-feedback d-block">{{`${localizationResource}::MustBeInteger` | abpLocalization}}</small>
        } @else if (form.get('CurrentRotation')?.hasError('min')) {
        <small class="invalid-feedback d-block"
          >{{`${localizationResource}::MustBeGreaterThan` | abpLocalization : '0'}}</small
        >
        } }
      </div>
    </div>
  </div>
</fieldset>

<fieldset>
  <legend>
    {{`${localizationResource}::Stand.AreaMaintenance`| abpLocalization}}
    <hr />
  </legend>

  <div class="row">
    <div class="col-4">
      <div class="form-control-container">
        <label class="form-label" for="Period">
          {{`${localizationResource}::Stand.MaintenancePeriod`| abpLocalization}} @if
          (isMaintenanceSectionRequired()) {
            <span class="form-label-required">*</span>
          }
        </label>
        <zn-single-select
          id="Period"
          [options]="periodOptions()"
          [optionsLoader]="loadPeriod"
          [showSearch]="true"
          formControlName="Period"
          [errorEntityKey]="`${localizationResource}::DefaultErrorRequired`"
          [localizationResource]="localizationResource"
          [openUp]="false"
        >
        </zn-single-select>
        @if (fieldInvalid('Period')) { @if
        (form.get('Period')?.hasError('required')) {
        <small class="invalid-feedback d-block">{{`${localizationResource}::DefaultErrorRequired` | abpLocalization}}</small>
        } }
      </div>
    </div>

    <div class="col-4">
      <div class="form-control-container">
        <label class="form-label" for="Reason">
          {{`${localizationResource}::Stand.MaintenanceReason`| abpLocalization}} @if
          (isMaintenanceSectionRequired()) {
            <span class="form-label-required">*</span>
          }
        </label>
        <zn-single-select
          id="Reason"
          [options]="reasonOptions()"
          [optionsLoader]="loadReason"
          [showSearch]="true"
          formControlName="Reason"
          [errorEntityKey]="`${localizationResource}::DefaultErrorRequired`"
          [localizationResource]="localizationResource"
          [openUp]="false"
        >
        </zn-single-select>
        @if (fieldInvalid('Reason')) { @if
        (form.get('Reason')?.hasError('required')) {
        <small class="invalid-feedback d-block">{{`${localizationResource}::DefaultErrorRequired` | abpLocalization}}</small>
        } }
      </div>
    </div>

    <div class="col-4">
      <div class="form-control-container">
        <label class="form-label" for="AdjustmentType">
          {{`${localizationResource}::Stand.AdjustmentType`| abpLocalization}} @if
          (isMaintenanceSectionRequired()) {
          <span class="form-label-required">*</span>
          }
        </label>
        <zn-single-select
          id="AdjustmentType"
          [options]="adjustmentTypeOptions()"
          [optionsLoader]="loadAdjustmentTypes"
          [showSearch]="true"
          formControlName="AdjustmentType"
          [errorEntityKey]="`${localizationResource}::DefaultErrorRequired`"
          [localizationResource]="localizationResource"
          [openUp]="false"
        >
        </zn-single-select>
        @if (fieldInvalid('AdjustmentType')) { @if
        (form.get('AdjustmentType')?.hasError('required')) {
        <small class="invalid-feedback d-block">{{`${localizationResource}::DefaultErrorRequired` | abpLocalization}}</small>
        } }
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-8">
      <div class="form-control-container">
        <label class="form-label" for="Notes">
          {{`${localizationResource}::StandAreaMaintenance.Notes`| abpLocalization}}
        </label>
        <input
          id="Notes"
          class="form-control"
          type="text"
          formControlName="Notes"
          [attr.maxlength]="standAreaMaintenanceNotesMaxLength"
          [placeholder]="`${localizationResource}::EnterText` | abpLocalization"
        />
      </div>
    </div>

    <div class="col-4">
      <div class="form-control-container">
        <label class="form-label form-check-label" for="IsAreaUpdated">
          {{`${localizationResource}::Stand.UpdatedArea`| abpLocalization}}
        </label>
        <div class="form-check-inner-container">
          <input
            id="IsAreaUpdated"
            class="form-check-input check-lg order-first"
            type="checkbox"
            formControlName="IsAreaUpdated"
          />
        </div>
      </div>    
    </div>
  </div>
</fieldset>

<fieldset>
  <legend>
    {{`${localizationResource}::Stand.Plantation`| abpLocalization}}
    <hr />
    <div class="form-control-container form-check form-switch">
      <label class="form-check-label" for="IsPlanted">
        {{`${localizationResource}::Stand.IsPlanted`| abpLocalization}}
      </label>
      <input
        class="form-check-input"
        type="checkbox"
        role="switch"
        id="IsPlanted"
        formControlName="IsPlanted"
        (change)="togglePlanted($event)"
        [aria-checked]="isPlanted()" 
      />
    </div>
  </legend>

  @if (isPlanted()) {
  <div class="row">
    <div class="col-4">
      <div class="form-control-container">
        <label class="form-label" for="PlantingDate">
          {{`${localizationResource}::Stand.PlantingDate`| abpLocalization}}
          <span class="form-label-required">*</span>
        </label>
        <input
          id="PlantingDate"
          class="form-control"
          [ngClass]="{
              'is-valid': form.get('PlantingDate')?.valid && (form.get('PlantingDate')?.touched || form.get('PlantingDate')?.dirty),
              'is-invalid': fieldInvalid('PlantingDate') && !dp.isOpen()
            }"
          ngbDatepicker
          [markDisabled]="disabledDates"
          [maxDate]="today"
          #dp="ngbDatepicker"
          #plantingDateInput
          appDateMask
          formControlName="PlantingDate"
          [placeholder]="`${localizationResource}::DateFormat` | abpLocalization"
          tabindex="0"
          (click)="dp.toggle()"
          (blur)="onPlantingDateBlur(plantingDateInput)"
        />
        @if (fieldInvalid('PlantingDate')) { @if
        (form.get('PlantingDate')?.hasError('required')) {
        <small class="invalid-feedback d-block">{{`${localizationResource}::DefaultErrorRequired` | abpLocalization}}</small>
        } @if (form.get('PlantingDate')?.hasError('futureDate')) {
        <small class="invalid-feedback d-block"
          >{{`${localizationResource}::DefaultErrorFutureDate` | abpLocalization}}</small
        >
        } @if (form.get('PlantingDate')?.hasError('invalidDate')) {
        <small class="invalid-feedback d-block">{{`${localizationResource}::InvalidDateFormat` | abpLocalization}}</small>
        } }
      </div>
    </div>

    <div class="col-4">
      <div class="form-control-container">
        <label class="form-label" for="PlantingType">
          {{`${localizationResource}::Stand.PlantingType`| abpLocalization}}
          <span class="form-label-required">*</span>
        </label>
        <zn-single-select
          id="PlantingType"
          [options]="plantingTypeOptions()"
          [optionsLoader]="plantingTypesLoader"
          [showSearch]="true"
          formControlName="PlantingType"
          [errorEntityKey]="`${localizationResource}::DefaultErrorRequired`"
          [localizationResource]="localizationResource"
          [openUp]="false"
        >
        </zn-single-select>
        @if (fieldInvalid('PlantingType')) { @if
        (form.get('PlantingType')?.hasError('required')) {
        <small class="invalid-feedback d-block">{{`${localizationResource}::DefaultErrorRequired` | abpLocalization}}</small>
        } }
      </div>
    </div>

    <div class="col-4">
      <div class="form-control-container">
        <label class="form-label form-check-label" for="ownPlantation">
          {{`${localizationResource}::Stand.OwnPlantation`| abpLocalization}}
        </label>
        <div class="form-check-inner-container">
          <input
            id="ownPlantation"
            class="form-check-input check-lg order-first"
            type="checkbox"
            formControlName="ownPlantation"
          />
        </div>
      </div>
    </div>

    <div class="col-4">
      <div class="form-control-container">
        <label class="form-label" for="Spacing">
          {{`${localizationResource}::Stand.Spacing`| abpLocalization}}
          <span class="form-label-required">*</span>
        </label>
        <zn-single-select
          id="Spacing"
          [options]="spacingOptions()"
          [optionsLoader]="spacingsLoader"
          [showSearch]="true"
          formControlName="Spacing"
          [errorEntityKey]="`${localizationResource}::DefaultErrorRequired`"
          [localizationResource]="localizationResource"
          [openUp]="false"
        >
        </zn-single-select>
        @if (fieldInvalid('Spacing')) { @if
        (form.get('Spacing')?.hasError('required')) {
        <small class="invalid-feedback d-block">{{`${localizationResource}::DefaultErrorRequired` | abpLocalization}}</small>
        } }
      </div>
    </div>

    <div class="col-4">
      <div class="form-control-container">
        <label class="form-label" for="GeneticMaterial">
          {{`${localizationResource}::Stand.GeneticMaterial`| abpLocalization}}
          <span class="form-label-required">*</span>
        </label>
        <zn-single-select
          id="GeneticMaterial"
          [options]="geneticMaterialOptions()"
          [optionsLoader]="geneticMaterialsLoader"
          [showSearch]="true"
          formControlName="GeneticMaterial"
          [errorEntityKey]="`${localizationResource}::DefaultErrorRequired`"
          [localizationResource]="localizationResource"
          [openUp]="false"
        >
        </zn-single-select>
        @if (fieldInvalid('GeneticMaterial')) { @if
        (form.get('GeneticMaterial')?.hasError('required')) {
        <small class="invalid-feedback d-block">{{`${localizationResource}::DefaultErrorRequired` | abpLocalization}}</small>
        } }
      </div>
    </div>

    <div class="col-4">
      <div class="form-control-container">
        <label class="form-label" for="Species">
          {{`${localizationResource}::Stand.Species`| abpLocalization}}
          <span class="form-label-required">*</span>
        </label>
        <input
          id="Species"
          class="form-control"
          type="text"
          [value]="speciesDisplayValue()"
          readonly
          disabled
          [placeholder]="`${localizationResource}::EnterText` | abpLocalization"
        />
      </div>
    </div>
  </div>
  }
</fieldset>
</div>
